import {
  getResource,
  GetTaskDetail,
  getTaskDetail,
  updateInterceptStatus,
} from '@/api/data-protection/task-detail'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { t } from '@/i18n'
export interface DetailFile {
  id?: string
  file_format_type: number
  compress_type: number
  leak_type: number
  protect_status: number
  send_file_hash: string
  received_file_hash: string
  file_status: number
  abnormal_reason: string
  is_finished: number
}
// 任务详情
export const useGetTaskDetail = () => {
  const { data, runAsync: run } = useRequest((record: GetTaskDetail) => getTaskDetail(record), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取任务信息失败'))
    },
  })
  return [(data?.data as DetailFile) || {}, run] as const
}

// 任务文件详情
export const useGetResource = () => {
  const { data, runAsync: run } = useRequest(params => getResource(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('任务文件详情失败'))
    },
  })
  return [data?.data?.items || [], data?.data?.manual_correct_count || 0, run] as const
}

// 修改拦截状态
export const useUpdateInterceptStatus = () => {
  const { runAsync: run, loading } = useRequest(params => updateInterceptStatus(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('修改拦截状态失败'))
    },
  })

  return [run, loading] as const
}
